import { render, staticRenderFns } from "./ShoppingListTabDetails.vue?vue&type=template&id=2e01dc97&scoped=true"
import script from "./ShoppingListTabDetails.vue?vue&type=script&lang=ts"
export * from "./ShoppingListTabDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e01dc97",
  null
  
)

export default component.exports